export const sendMessage = (ws) => {
  // 
  ws.emit('event01', { data: '回傳發送訊息的...' }, (response) => {
    // 
  });
  ws.emit('create-node', { data: '回傳發送訊息的...' }, (response) => {
    // 
  });
};

export const sendNewNodeMessage = (ws, node) => {
  // 

  ws.emit('create-node', node, (response) => {
    // 
  });
};

export const sendNewEdgeMessage = (ws, edge) => {
  // 

  ws.emit('create-edge', edge, (response) => {
    // 
  });
};

// export const joinRoom = (ws, groupId) => {
//   // 

//   ws.emit('join-room', groupId, (response) => {
//     // 
//   });
// };
